import { STATUSPAGE } from '@repo/ui';
import { ImpersonatePersonUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function usePersonImpersonate() {
  // Hooks
  const pathParams = useParams();
  const navigate = useNavigate();

  // States
  const [error, setError] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [requestStatus, setRequestStatus] = useState(STATUSPAGE.INITIAL);
  const [impersonatePersonResponse, setImpersonatePersonResponse] = useState<
    ImpersonatePersonUseCaseInterface.Result | undefined
  >(undefined);

  const { impersonateService } = useService();

  // Methods
  const requestImpersonatePerson = useCallback(
    async (params: ImpersonatePersonUseCaseInterface.Params) => {
      setRequestStatus(STATUSPAGE.LOADING);
      impersonateService
        .impersonatePerson(params)
        .then((res) => {
          setImpersonatePersonResponse(res);
          setTimeout(() => {
            window.location.replace(res.redirectUrl);
          }, 3000);
        })
        .catch((res) => {
          setError(true);
          notifyError(res.message || 'Erro ao redirecionar para a plataforma');
          const timer = setInterval(() => {
            setCountdown((prevCountdown) => {
              if (prevCountdown === 1) {
                clearInterval(timer);
                window.close();
              }
              return prevCountdown - 1;
            });
          }, 1000);
        })
        .finally(() => {
          setRequestStatus(STATUSPAGE.DONE);
        });
    },
    [],
  );
  return {
    error,
    countdown,
    pathParams,
    requestStatus,
    impersonatePersonResponse,
    navigate,
    requestImpersonatePerson,
  };
}
